
import React from 'react';
import { Area, AreaStatus } from '../app/types';
import { GetAreaDTO } from '../models/AreaDTO';


interface AreaListPageProps {
  areas: GetAreaDTO[];
  idMembership: number;
  onEdit: (area: GetAreaDTO) => void;
  onAddNew: () => void;
  onBack: () => void;
}

const BackArrowIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" /></svg>;
const PlusIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" /></svg>;

const StatusChip: React.FC<{ status: AreaStatus }> = ({ status }) => {
  const isActive = status === AreaStatus.ACTIVO;
  return (
    <span
      className={`px-2.5 py-1 text-xs font-medium rounded-full ${
        isActive
          ? 'bg-primary-container text-on-primary-container dark:bg-dark-primary-container dark:text-dark-on-primary-container'
          : 'bg-surface-variant text-on-surface-variant dark:bg-dark-surface-variant dark:text-dark-on-surface-variant'
      }`}
    >
      {status}
    </span>
  );
};

const AreaListPage: React.FC<AreaListPageProps> = ({ areas, onEdit, onAddNew, onBack }) => {
  return (
    <>
      <div className="bg-surface dark:bg-dark-surface p-6 rounded-3xl shadow-sm">
        <div className="flex justify-between items-center mb-6">
          <div style={{textAlign:"left"}}>
            <h2 className="text-2xl font-medium text-on-surface dark:text-dark-on-surface">Gestión de Áreas</h2>
            <p className="text-on-surface-variant dark:text-dark-on-surface-variant mt-1">Crea, edita y visualiza las áreas de la empresa.</p>
          </div>
          <button onClick={onBack}  className="flex items-center text-primary dark:text-dark-primary font-medium p-2 rounded-full hover:bg-primary/10 dark:hover:bg-dark-primary/10 transition-colors">
              <BackArrowIcon /> Volver
          </button>
        </div>
            
        <div className="overflow-x-auto bg-surface-container-low dark:bg-dark-surface-container-low rounded-xl">
          <table className="w-full text-left">
            <thead className="border-b border-outline-variant dark:border-dark-outline-variant">
              <tr>
                <th className="p-4 text-sm font-semibold text-on-surface-variant dark:text-dark-on-surface-variant">Nombre</th>
                <th className="p-4 text-sm font-semibold text-on-surface-variant dark:text-dark-on-surface-variant">Estado</th>              
              </tr>
            </thead>
            <tbody>
              {areas?.map((area, index) => (
                <tr key={area.Id} onClick={() => onEdit(area)} className={`border-b border-outline-variant/50 dark:border-dark-outline-variant/50 ${index === areas.length - 1 ? 'border-b-0 ' : ''}`} style={{cursor:"pointer"}}>
                  <td className="p-4 font-medium text-on-surface dark:text-dark-on-surface">{area.Name}</td>
                  <td className="p-4">
                    {area.Enabled === 1 ? <StatusChip status={AreaStatus.ACTIVO} /> : <StatusChip status={AreaStatus.INACTIVO} />}
                  </td>                
                </tr>
              ))}
            </tbody>
          </table>
          {areas.length === 0 && (
            <p className="p-8 text-center text-on-surface-variant dark:text-dark-on-surface-variant">No hay áreas para mostrar.</p>
          )}
        </div>      
      </div>
      <button
        onClick={onAddNew}
        aria-label="Crear Nueva Área"
        className="fixed bottom-8 right-8 z-30 inline-flex items-center justify-center w-14 h-14 bg-primary dark:bg-dark-primary text-on-primary dark:text-dark-on-primary rounded-xl shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary dark:focus:ring-dark-primary transition-all duration-300 transform hover:scale-105"
      >
        <PlusIcon />
      </button>
    </>
  );
};

export default AreaListPage;
